import {useTranslation} from '@/translations/i18n'
import {DetailsPageContentTabWrapper} from '@/components/ui/details-atoms/DetailsAtoms'
import {Tab, Tabs} from '@/components/ui/tab-atoms/TabAtoms'
import {routes} from '@/utilities/constants/routes'
import {StyledWrapper} from './style'

export const ProjectsTabs = () => {
    const {t} = useTranslation()

    return (
        <StyledWrapper>
            <DetailsPageContentTabWrapper>
                <Tabs paddingX={4}>
                    <Tab to={routes.PROJECTS_ROUTE.handle.path} end>
                        {t('projects:projects_tab')}
                    </Tab>
                    <Tab to={routes.SIAR_EXPORT_HISTORY.handle.path}>
                        {t('projects:bulk_siar_export_history_title')}
                    </Tab>
                </Tabs>
            </DetailsPageContentTabWrapper>
        </StyledWrapper>
    )
}
